import ProjectItem from '../components/ProjectItem';
import { useContext } from 'react';
import MainContext from '../store/main-context';
import SideAreaTitle from '../components/SideAreaTitle';
import type { PortfolioItem, PortfolioProps } from '../store/types';

const Portfolio = ({ openProject }: PortfolioProps) => {

    const ctx = useContext(MainContext);
    const projects = ctx?.portfolio;

    return (
        <section className="col-lg-9 col-xl-7 fh-100 side-area-container" aria-labelledby="portfolio-page-title">
            <div className="white_box"></div>
            <section className="box_container w-100  pos-z yellow" aria-labelledby="portfolio-page-title">
                <SideAreaTitle id="portfolio-page-title" title="Portfolio" colorClass="yellow" />
                <section className="row pb-5" aria-label="Portfolio projects">
                    {projects?.map(function (portfolio: PortfolioItem, i: number) {
                        return (
                            <ProjectItem portfolio={portfolio} key={portfolio.id}
                                href={`/my-portfolio/${portfolio.key}`}
                                click={() => {
                                    if (openProject) {
                                        openProject(portfolio, i);
                                        return;
                                    }
                                    ctx.setActivePortfolio(i);
                                }}
                            />
                        )
                    })}
                    {projects?.length === 0 && (
                        <div className="col-12">
                            <p className="fw-600 text-white">
                                Portfolio items are being updated. Please check back soon.
                            </p>
                        </div>
                    )}
                </section>
            </section>
        </section>
    )
}

export default Portfolio;
